<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../../api.js';
    import UserStore from '../../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../../components/Header.svelte'; 
    import TopInfo from '../../components/TopInfo.svelte';  
    import Preloader from '../../components/Preloader.svelte'; 
    import License from '../../components/License.svelte'; 
    import Token from '../../components/Token.svelte'; 
    

    let isLoading = false;


    onMount(async() => {

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }
    })


    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment">
            
            <Token />
              
            <div class="container content-container wix m-0 p-0">
                <h1 class="text-3xl font-bold mb-4">{$_('docs.wix.title')}</h1>
            
                <h2 id="wix-installation" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.wix.installation.title')}</h2>
                <p class="text-base mb-4">{$_('docs.wix.installation.intro')}</p>
                <p class="text-base mb-4">
                {$_('docs.wix.installation.skip_intro.before_link')}
                <br>
                <a href="https://www.wix.com/app-market/israel-post-domestic" target="_blank" class="text-blue-600 hover:underline">
                    {$_('docs.wix.installation.skip_intro.link_text')}
                </a>
                </p>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wix.installation.app_store_access')}</h3>
                <ol class="list-decimal list-inside mb-4">
                <li>{$_('docs.wix.installation.app_store_step_1')}</li>
                <li>{$_('docs.wix.installation.app_store_step_2')}</li>
                <li>{$_('docs.wix.installation.app_store_step_3')}</li>
                </ol>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wix.installation.find_app')}</h3>
                <ol class="list-decimal list-inside mb-4">
                <li>{$_('docs.wix.installation.find_app_step_1')}</li>
                <li>{$_('docs.wix.installation.find_app_step_2')}</li>
                </ol>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wix.installation.install')}</h3>
                <ol class="list-decimal list-inside mb-4">
                <li>{$_('docs.wix.installation.install_step_1')}</li>
                <li>{$_('docs.wix.installation.install_step_2')}</li>
                <li>{$_('docs.wix.installation.install_step_3')}</li>
                </ol>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wix.installation.permissions')}</h3>
                <ol class="list-decimal list-inside mb-4">
                <li>{$_('docs.wix.installation.permissions_step_1')}</li>
                <li>{$_('docs.wix.installation.permissions_step_2')}</li>
                </ol>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wix.installation.completion')}</h3>
                <ol class="list-decimal list-inside mb-4">
                <li>{$_('docs.wix.installation.completion_step_1')}</li>
                <li>{$_('docs.wix.installation.completion_step_2')} {docs_shipping_company_name} {$_('docs.wix.installation.completion_step_2_1')}</li>
                </ol>
            
                <p class="text-base mb-4">{$_('docs.wix.installation.success')} {docs_shipping_company_name} {$_('docs.wix.installation.success_1')}</p>
                <p class="text-base mb-4">{$_('docs.wix.installation.support_info')}</p>
            
                <h2 id="wix-getting-started" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.wix.getting_started.title')}</h2>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wix.getting_started.configuration')}</h3>
                <p class="text-base mb-4">{$_('docs.wix.getting_started.config_intro')}</p>
                <ol class="list-decimal list-inside mb-4">
                <li>{$_('docs.wix.getting_started.config_step_1')}</li>
                <li>{$_('docs.wix.getting_started.config_step_2')} {docs_shipping_company_name} {$_('docs.wix.getting_started.config_step_2_1')}</li>
                </ol>
            
                <h4 class="text-lg font-medium mt-3 mb-2">{$_('docs.wix.getting_started.account_settings')}</h4>
                <p class="text-base mb-4">{$_('docs.wix.getting_started.account_settings_intro')}</p>
                <ul class="list-disc list-inside mb-4">
                <li>{$_('docs.wix.getting_started.account_settings_step_1')}</li>
                </ul>
            
                <h2 id="wix-usage" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.wix.usage.title')}</h2>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wix.usage.shipping_labels')}</h3>
                <p class="text-base mb-4">{$_('docs.wix.usage.shipping_labels_intro')}</p>
            
                <h4 class="text-lg font-medium mt-3 mb-2">{$_('docs.wix.usage.orders_page')}</h4>
                <ol class="list-decimal list-inside mb-4">
                <li><strong>{$_('docs.wix.usage.orders_page_step_1_title')}</strong> {$_('docs.wix.usage.orders_page_step_1')}</li>
                </ol>
            
                <h4 class="text-lg font-medium mt-3 mb-2">{$_('docs.wix.usage.order_page')}</h4>
                <ol class="list-decimal list-inside mb-4">
                <li><strong>{$_('docs.wix.usage.order_page_step_1_title')}</strong> {$_('docs.wix.usage.order_page_step_1')}</li>
                </ol>
            
                <p class="text-base mb-4">{$_('docs.wix.usage.summary')}</p>
            
                <h2 id="wix-troubleshooting" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.wix.troubleshooting.title')}</h2>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wix.troubleshooting.common_issues')}</h3>
                <p class="text-base mb-4"></p>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wix.troubleshooting.faq')}</h3>
                <ol class="list-decimal list-inside mb-4">
                <li>
                    <div><strong>{$_('docs.wix.troubleshooting.faq_1_q')}</strong></div>
                    <div>{$_('docs.wix.troubleshooting.faq_1_a')}</div>
                </li>
                <li>
                    <div><strong>{$_('docs.wix.troubleshooting.faq_2_q')}</strong></div>
                    <div>{$_('docs.wix.troubleshooting.faq_2_a')}</div>
                </li>
                </ol>
            
                <h2 id="wix-support" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.wix.support.title')}</h2>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wix.support.getting_help')}</h3>
                <p class="text-base mb-4">{$_('docs.wix.support.getting_help_intro')}</p>
                <ol class="list-decimal list-inside mb-4">
                <li><strong>{$_('docs.wix.support.help_step_1_title')}</strong> {$_('docs.wix.support.help_step_1')}</li>
                <li><strong>{$_('docs.wix.support.help_step_2_title')}</strong> {$_('docs.wix.support.help_step_2')}</li>
                </ol>
            
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wix.support.reporting')}</h3>
                <p class="text-base mb-4">{$_('docs.wix.support.reporting_intro')}</p>
                <ol class="list-decimal list-inside mb-4">
                <li><strong>{$_('docs.wix.support.report_step_1_title')}</strong> {$_('docs.wix.support.report_step_1')}</li>
                <li><strong>{$_('docs.wix.support.report_step_2_title')}</strong> {$_('docs.wix.support.report_step_2')}</li>
                </ol>
            
                <h2 id="wix-changelog" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.wix.changelog.title')}</h2>
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.wix.changelog.version')}</h3>
                <ul class="list-disc list-inside mb-4">
                <li><strong>{$_('docs.wix.changelog.added_title')}</strong> {$_('docs.wix.changelog.added')}</li>
                <li><strong>{$_('docs.wix.changelog.updated_title')}</strong> {$_('docs.wix.changelog.updated')}</li>
                <li><strong>{$_('docs.wix.changelog.fixed_title')}</strong> {$_('docs.wix.changelog.fixed')}</li>
                <li><strong>{$_('docs.wix.changelog.removed_title')}</strong> {$_('docs.wix.changelog.removed')}</li>
                </ul>
            
                <h2 id="wix-license" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.wix.license.title')}</h2>
                <License />
            </div>

        </div>
    </div>
</div>